/* Typewriter idle hint: constant "Search for " + cycling collection names. */
(function () {
  var PREFIX = 'Search for ';
  var TYPE_MS = 85;
  var DELETE_MS = 45;
  var PAUSE_MS = 2200;
  var FALLBACK = ['Lehenga Sets', 'Anarkalis', 'New Arrivals'];

  function isSpecificCollectionPath(href) {
    try {
      href = new URL(href, window.location.origin).pathname;
    } catch (e) {
      /* keep raw href */
    }
    return /^\/collections\/[^/]+/.test(href);
  }

  function isSkippedPhrase(text) {
    return String(text || '').trim().toLowerCase() === 'collections';
  }

  function isCollectionNavItem(item) {
    var link = item.querySelector('a.header__linklist-link[href]');
    if (!link) return false;
    return isSpecificCollectionPath(link.getAttribute('href') || '');
  }

  function collectPhrases() {
    var seen = {};
    var list = [];

    function add(text) {
      text = (text || '').trim();
      if (!text || isSkippedPhrase(text) || seen[text.toLowerCase()]) return;
      seen[text.toLowerCase()] = true;
      list.push(text);
    }

    var chips = document.querySelectorAll('#search-drawer [data-fill-search]');
    for (var c = 0; c < chips.length; c++) {
      add(chips[c].getAttribute('data-fill-search'));
    }

    var items = document.querySelectorAll(
      '.header__bottom-navigation .header__linklist-item[data-item-title]'
    );
    for (var i = 0; i < items.length; i++) {
      if (!isCollectionNavItem(items[i])) continue;
      add(items[i].getAttribute('data-item-title'));
    }

    return list.length ? list : FALLBACK.slice();
  }

  function attachTypingHint(container, options) {
    options = options || {};
    var hideOnFocus = options.hideOnFocus !== false;
    var requireOpen = options.requireOpen === true;
    var openHost = options.openHost || null;

    var input = container.querySelector('input[name="q"]');
    var hint = container.querySelector('.predictive-search__typing-hint');
    if (!input || !hint) return null;

    var phrases = collectPhrases();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var phraseIndex = 0;
    var charIndex = 0;
    var deleting = false;
    var timerId = null;
    var running = false;

    input.setAttribute('placeholder', '');

    function isOpen() {
      if (!requireOpen || !openHost) return true;
      return openHost.hasAttribute('open');
    }

    function isIdle() {
      if (!isOpen() || input.value) return false;
      if (hideOnFocus && document.activeElement === input) return false;
      return true;
    }

    function setHintVisible(show) {
      hint.classList.toggle('is-hidden', !show);
    }

    function renderHint(suffix) {
      hint.textContent = PREFIX + suffix;
    }

    function clearTimer() {
      if (timerId !== null) {
        clearTimeout(timerId);
        timerId = null;
      }
    }

    function stop() {
      running = false;
      clearTimer();
      setHintVisible(false);
    }

    function schedule(ms, fn) {
      clearTimer();
      timerId = setTimeout(fn, ms);
    }

    function tick() {
      if (!running || !isIdle()) {
        stop();
        return;
      }

      var phrase = phrases[phraseIndex];

      if (!deleting && charIndex <= phrase.length) {
        renderHint(phrase.slice(0, charIndex));
        setHintVisible(true);
        if (charIndex === phrase.length) {
          deleting = true;
          schedule(PAUSE_MS, tick);
          return;
        }
        charIndex += 1;
        schedule(TYPE_MS, tick);
        return;
      }

      if (deleting && charIndex >= 0) {
        renderHint(phrase.slice(0, charIndex));
        if (charIndex === 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % phrases.length;
          schedule(TYPE_MS, tick);
          return;
        }
        charIndex -= 1;
        schedule(DELETE_MS, tick);
        return;
      }

      schedule(TYPE_MS, tick);
    }

    function start() {
      if (running) return;
      if (!phrases.length || !isIdle()) return;

      if (reducedMotion) {
        renderHint(phrases[phraseIndex] || phrases[0]);
        setHintVisible(true);
        return;
      }

      running = true;
      charIndex = 0;
      deleting = false;
      tick();
    }

    function sync() {
      if (!isIdle()) {
        stop();
        return;
      }
      if (reducedMotion) {
        renderHint(phrases[phraseIndex] || phrases[0]);
        setHintVisible(true);
        return;
      }
      if (!running) start();
    }

    function resetCycle() {
      charIndex = 0;
      deleting = false;
      running = false;
      clearTimer();
    }

    input.addEventListener('input', sync);

    if (hideOnFocus) {
      input.addEventListener('focus', stop);
      input.addEventListener('blur', sync);
    }

    container.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-action="clear-input"]')) {
        schedule(0, sync);
      }
      if (e.target.closest && e.target.closest('[data-fill-search]')) {
        schedule(0, stop);
      }
    });

    if (openHost) {
      openHost.addEventListener('openable-element:open', function () {
        resetCycle();
        schedule(150, sync);
      });
      openHost.addEventListener('openable-element:close', function () {
        stop();
        resetCycle();
      });
    }

    sync();

    return { sync: sync, stop: stop };
  }

  function init() {
    var pill = document.querySelector('.header__search-bar');
    var drawer = document.getElementById('search-drawer');
    var pillApi = pill ? attachTypingHint(pill, { hideOnFocus: true }) : null;
    var drawerApi = drawer
      ? attachTypingHint(drawer, {
          hideOnFocus: false,
          requireOpen: true,
          openHost: drawer
        })
      : null;

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (pillApi) pillApi.stop();
        if (drawerApi) drawerApi.stop();
      } else {
        if (pillApi) pillApi.sync();
        if (drawerApi) drawerApi.sync();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
